import KitneticLogo from '@/assets/branding/kitnetic/KiTNETiC_Logo.png';

const colors = {
  // Brand colors
  brand_primary: '#CE79E7',
  brand_primary_hover: '#B45ACF', // −10 L, −8 S
  brand_primary_highlight: '#E7B5F4', // +23 L, +7 S
  brand_primary_mid: '#D48AEF', // +8 L,  +2 S
  brand_primary_dark: '#7A2D99', // −25 L, −3 S (clamped)
  // Use one of the additional brand colors as a secondary/accent
  brand_secondary: '#FF66C4', // pink accent, roughly hue +4°, −15 L, −13 S from primary
  brand_accent_start: '#D88EF0',
  brand_accent_end: '#7A9BFF',
  brand_accent_light_start: '#F9EEFD',
  brand_accent_light_end: '#E8EDFF',
  brand_complementary_accent: 'rgb(121,226,90)',
  brand_auth_gradient_mid: '#FF66C4',
  brand_auth_gradient_end: '#7A2D99',
  brand_auth_warp_mid: '#D48AEF',
};

export default {
  name: 'KiTNETiC',
  isSAML: true,
  allowPersonalCourses: false,
  logo: KitneticLogo,
  colors,
};
